import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsPageComponent } from './transport-interventions-page.component';
import {TabModule} from '../../tab/tab.module';
import {TransportInterventionsToolbarModule} from '../transport-interventions-toolbar/transport-interventions-toolbar.module';
import {TransportInterventionsGridModule} from '../transport-interventions-grid/transport-interventions-grid.module';

import {TransportInterventionsDashboardModule} from '../transport-interventions-dashboard/transport-interventions-dashboard.module';
import {TransportInterventionsPivotGridModule} from '../transport-interventions-pivot-grid/transport-interventions-pivot-grid.module';
import {TransportInterventionsSettingsModule} from '../transport-interventions-settings/transport-interventions-settings.module';




@NgModule({
  declarations: [TransportInterventionsPageComponent],
  imports: [
    CommonModule,
    TabModule,
    TransportInterventionsToolbarModule,
    TransportInterventionsGridModule,
    TransportInterventionsDashboardModule,
    TransportInterventionsPivotGridModule,
    TransportInterventionsSettingsModule
  ],
  exports: [TransportInterventionsPageComponent]
})
export class TransportInterventionsPageModule { }
